<script setup lang="ts">
import type { ImgHTMLAttributes } from 'vue';


interface Props {
  name: string
  profilePicture?: string | undefined
  loading?: ImgHTMLAttributes['loading'] | undefined
}

const props = withDefaults(defineProps<Props>(), {
  loading: 'lazy'
})

function initialsOf(name: string) {

  const names = name.split(' ')
  let initials = ''
  
  for(let i = 0; i < 2; i++) {

    const initial = names[i]?.[0] ?? ''
    initials += i === 0 ? initial : initial.toLowerCase()

  }

  return initials
}

</script>

<template>
  <span
    class="rounded-full relative w-9 h-9 flex items-center justify-center isolate"
  >

    <!-- background -->
    <span class="absolute w-full h-full bg-brand-gradient rounded-full" />

    <!-- darken background -->
    <span class="inset-.5 absolute rounded-full bg-brand-background/70" />

    <!-- conditional picture & initials -->
    <img 
      v-if="profilePicture"
      :src="profilePicture" 
      :alt="name"
      class="absolute rounded-full h-full w-full p-.5"
      :loading="props.loading"
    />

    <span 
      v-else 
      class="text-white text-[0.625rem] font-bold relative"
      role="presentation"
    >
      {{ initialsOf(name) }}
    </span>
    <span class="sr-only" >
      {{ name }}
    </span>

  </span>
</template>
